import { paths } from '../../config';
import MainContainer from '../main-container';
import Form from './customerServiceForm';
import List from './customerServiceList';

const settings = {
    pathRegister: paths.customerServiceRegister,
    pathList: paths.customerService,
    apiPath: 'customer-services',
    permissionAdmin: null,
    title: 'Atendimento',
};

const FormEntity: React.FC = () => {
    return (
        <MainContainer>
            <Form settings={settings} />
        </MainContainer>
    );
};

const ListEntity: React.FC = () => {
    return (
        <MainContainer>
            <List settings={{ ...settings, title: 'Atendimentos' }} />
        </MainContainer>
    );
};

export { FormEntity, ListEntity };
